import { Svg } from 'components/svg'
import type { IconType } from 'models'

export const IconTelegram: IconType = ({ className = '' }) => (
  <Svg className={className} viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M9 12.8l-2.72-.89a.38.38 0 0 1-.28-.43c0-.06.07-.11.2-.2.6-.42 11.14-4.21 11.14-4.21a.94.94 0 0 1 .47 0 .25.25 0 0 1 .17.19 1 1 0 0 1 0 .24v.23c-.07 1-2 8.76-2 8.76s-.11.46-.53.47a.76.76 0 0 1-.55-.21c-.8-.69-3.6-2.57-4.21-3a.08.08 0 0 1-.05-.08.29.29 0 0 1 0-.1s4.86-4.32 5-4.77h-.07c-.33.12-5.92 3.65-6.54 4a.2.2 0 0 1-.03 0zm.29.4l.82 2.48.16-2.21a.1.1 0 0 1 0-.07l3.2-2.93zm1.35 1.1l-.16 2.19c.06.09.22.09.57-.26s.75-.71 1-.93z"
    />
  </Svg>
)
